import { Component, Inject, NgModule } from '@angular/core';
import { UntypedFormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { map, startWith, tap, combineLatest, Subject } from 'rxjs';
import { CommonModule, AsyncPipe } from '@angular/common';
import { SuggestedAmount, suggestedAmountTypes } from '@uw/core/models/suggested-amount.model';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { UnitedWay } from '@uw/core/models/unitedway.model';
import { AuthService } from '@uw/core/services/auth.service';

type SuggestedAmountDetailData = {
  targetTypeCode: { name: string, value: any },
  suggestedAmount: SuggestedAmount
};

@Component({
    selector: 'uw-switch-uw-modal',
    templateUrl: './switch-uw-modal.component.html',
    styleUrls: ['./switch-uw-modal.component.scss'],
    imports: [AsyncPipe, TranslateModule]
})
export class SwitchUwModalComponent {

  private readonly _selectUWSubject: Subject<UnitedWay> = new Subject();

  private readonly _selectedUnitedWay$ = this._selectUWSubject.asObservable();

  readonly suggestedAmountTypes: typeof suggestedAmountTypes = suggestedAmountTypes;

  private _targetTypeCode!: string;

  readonly vm$ = combineLatest([
    this.authService.getUnitedWayList(),
    this._selectedUnitedWay$
      .pipe(
        tap(unitedWay => this._dialogRef.close(unitedWay)),
        startWith(true)
      )
  ]).pipe(
    map(([unitedWayList, query]) => {
      return {
        unitedWayList
      };
    })
  )

  constructor(
    @Inject(MAT_DIALOG_DATA) data: any,
    private readonly _dialogRef: MatDialogRef<SwitchUwModalComponent>,
    private authService: AuthService
  ) {
  }

  onSelect(unitedWay: any) {
    this._selectUWSubject.next(unitedWay);
  }
}
